import { render, staticRenderFns } from "./BarcodePreviewModal.vue?vue&type=template&id=6b2584b0&scoped=true&"
import script from "./BarcodePreviewModal.vue?vue&type=script&lang=js&"
export * from "./BarcodePreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./BarcodePreviewModal.vue?vue&type=style&index=0&id=6b2584b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2584b0",
  null
  
)

export default component.exports